module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "now"
  }, [_vm._v("now")]), _c('span', {
    staticClass: "yu"
  }, [_vm._v("yu")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "mt6": "",
      "primary": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.signIn()
      }
    }
  }, [_vm._v("Login")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5caae665","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 394
// module chunks = 0